import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { apiUrl } from 'app/core/config/app.config';
import { switchMap } from 'rxjs/operators';
import { Usuarios } from 'app/models/Usuario/usuarios.model';
import { Adiantamento } from 'app/models/Adiantamento/adiantamento';
import { Deposito } from 'app/models/Usuario/deposito.model';

@Injectable({
    providedIn: 'root'
})
export class UsuarioService {
    criarApostador(usuario: Usuarios) {
        return this.http.put(apiUrl + 'v1/usuario/criar-usuario-apostador', usuario, { responseType: 'text' });
    }

    constructor(private http: HttpClient) { }

    public getVendedores(): Observable<any> {
        return this.http.get(apiUrl + 'v1/usuario/vendedores').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public novoDeposito(deposito: Deposito) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        return this.http.post(apiUrl + 'v1/deposito/novo-deposito', deposito, {headers});
    }

    public getDepositoId(deposito: Deposito): Observable<any> {
        return this.http.post(apiUrl + "v1/deposito/deposito-id", deposito, {
            responseType: "text",
        });
    }

    public getVendedoresAtivos(): Observable<any> {
        return this.http.get(apiUrl + 'v1/usuario/vendedores-ativos').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public getGerentes(): Observable<any> {
        return this.http.get(apiUrl + 'v1/usuario/gerentes').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public getAdiantamentos(): Observable<any> {
        return this.http.get(apiUrl + 'v1/usuario/adiantamentos').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public criarAdiantamento(adiantamento: Adiantamento) {

        return this.http.put(apiUrl + 'v1/usuario/criar-adiantamento', adiantamento, { responseType: 'text' });
    }

    public excluirAdiantamento(adiantamento: Adiantamento) {

        return this.http.post(apiUrl + 'v1/usuario/excluir-adiantamento', { id: adiantamento.id }, { responseType: 'text' });
    }

    public criarUsuario(usuario: Usuarios) {

        return this.http.put(apiUrl + 'v1/usuario/criar-usuario', usuario, { responseType: 'text' });
    }

    public editarUsuario(usuario: Usuarios) {

        return this.http.post(apiUrl + 'v1/usuario/editar-usuario', usuario, { responseType: 'text' });
    }

    public excluirUsuario(usuario: Usuarios) {

        return this.http.post(apiUrl + 'v1/usuario/excluir-usuario', { id: usuario.id }, { responseType: 'text' });

    }

    public alterarStatus(usuario: Usuarios) {

        return this.http.post(apiUrl + 'v1/usuario/alterar-status', usuario, { responseType: 'text' });

    }

    public alterarSenha(usuario: Usuarios) {

        return this.http.post(apiUrl + 'v1/usuario/alterar-senha', usuario, { responseType: 'text' });

    }
}




